

































import { EnvironmentMixin } from "@/helpers/environment-mixin";
import { Component, Prop, Mixins } from "vue-property-decorator";

@Component({})
export default class ProjectAccountingTabs extends Mixins<EnvironmentMixin>() {
  @Prop({ required: true }) projectId!: string;
  @Prop({ default: "" }) active!: string;
}
